import React from 'react'
import { StyleSheet, css } from 'aphrodite'
import { useTranslation } from 'react-i18next'

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    width: '100%',
    position: 'relative',
    alignItems: 'flex-start',
    '@media (max-width: 480px)': {
      flexDirection: 'column',
      display: 'block',
    },
  },
  title: {
    position: 'relative',
    width: '400px',
    height: '100px',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '60px',
    lineHeight: '58px',
    display: 'flex',
    alignItems: 'center',
    letterSpacing: '-0.03em',
    color: 'black',
    textAlign: 'center',
    margin: 'auto',
    marginTop: '5%',
    marginBottom: '5%',
    whiteSpace: 'nowrap',
    justifyContent: 'center',
    '@media (max-width: 480px)': {
      paddingTop: '20px',
      paddingBottom: '60px',
      margingLeft: 'auto',
      margingRight: 'auto',
      fontWeight: '600',
      fontSize: '10vw',
      lineHeight: '10vw',
      width: '50%',
    },
  },
  cityTitle: {
    width: '250px',
    position: 'absolute',
    top: '30%',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '60px',
    lineHeight: '58px',
    letterSpacing: '-0.03em',
    color: 'white',
    '@media (max-width: 1024px)': {
      fontSize: '40px',
    },
  },
  cityDesc: {
    width: '80%',
    position: 'absolute',
    top: '50%',
    marginLeft: '10%',
    marginRight: '10%',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '30px',
    lineHeight: '30px',
    textAlign: 'center',
    letterSpacing: '-0.03em',
    color: 'white',
    '@media (max-width: 1024px)': {
      top: '55%',
      fontSize: '20px',
    },
  },
  sectionImg: {
    display: 'block',
    position: 'relative',
    width: '80%',
    height: 'auto',
    margin: 'auto',
    marginBottom: '5%',
  },
})
function ProLoc() {
  const { t } = useTranslation('Pro')
  return (
    <div id="locations">
      <div className={css(styles.container)}>
        <p className={css(styles.title)}>
          {t('weAre')} <br />
          {t('here')}
        </p>
      </div>
    </div>
  )
}

export default ProLoc
